import { Outlet, createFileRoute } from '@tanstack/react-router';

function InspectionRecordLayout() {
	return <Outlet />;
}

export const Route = createFileRoute('/_authenticated/_app/inspection/inspections/$inspectionId')({
	component: InspectionRecordLayout,
});
